// extracted by mini-css-extract-plugin
module.exports = {"root":"AwsCurTemplate-module__root__Y67aR","input-description":"AwsCurTemplate-module__input-description__3tIU3"};